var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.636719C43.1125 0.636719 55.3633 12.8875 55.3633 28C55.3633 43.1125 43.1125 55.3633 28 55.3633C12.8875 55.3633 0.636719 43.1125 0.636719 28C0.636719 12.8875 12.8875 0.636719 28 0.636719Z",
    fill: "#EC4E22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.636719C43.1125 0.636719 55.3633 12.8875 55.3633 28C55.3633 43.1125 43.1125 55.3633 28 55.3633C12.8875 55.3633 0.636719 43.1125 0.636719 28C0.636719 12.8875 12.8875 0.636719 28 0.636719Z",
    stroke: "#EC4E22",
    strokeWidth: 1.27273,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_6421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4249 25.8794V28.0007C35.4249 29.9697 34.6427 31.8581 33.2504 33.2504C31.8581 34.6427 29.9697 35.4249 28.0007 35.4249M28.0007 35.4249C26.0316 35.4249 24.1432 34.6427 22.7509 33.2504C21.3586 31.8581 20.5764 29.9697 20.5764 28.0007V25.8794M28.0007 35.4249V39.6673M23.7582 39.6673H32.2431M28.0007 16.334C27.1568 16.334 26.3475 16.6692 25.7508 17.2659C25.1541 17.8626 24.8188 18.6719 24.8188 19.5158V28.0007C24.8188 28.8445 25.1541 29.6538 25.7508 30.2505C26.3475 30.8472 27.1568 31.1825 28.0007 31.1825C28.8445 31.1825 29.6538 30.8472 30.2505 30.2505C30.8472 29.6538 31.1825 28.8445 31.1825 28.0007V19.5158C31.1825 18.6719 30.8472 17.8626 30.2505 17.2659C29.6538 16.6692 28.8445 16.334 28.0007 16.334Z",
    stroke: "#FFF8F6",
    strokeWidth: 2.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_6421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4545,
    height: 25.4545,
    fill: "white",
    transform: "translate(15.2727 15.2734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.de77ce6d8298e2f219e6ee3128c8ec60.svg";
export { ForwardRef as ReactComponent };